import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import { useRouter } from 'next/router';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import StepUs3 from './StepUs3';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { locale } = useRouter();
    const { t } = useLang('dp3.landing.ConsultingService');
    const [list, setList] = useState([
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            icon: <Step1 />,
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            icon: <Step2 />,
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            icon: locale === 'jp' ? <Step3 /> : <StepUs3 />,
        },
        {
            title: t('item4_title'),
            desc: t('item4_desc'),
            icon: locale === 'jp' ? <Step4 /> : <Step5 />,
        },
        {
            title: t('item5_title'),
            desc: t('item5_desc'),
            icon: <Step5 />,
        },
    ]);
    const hrefCommon = `https://${locale}.ecoflow.com/products/smart-home-panel-2-installation-consulting-service?variant=40768226525257`;
    const hrefJp = `https://www.ecoflow.com/${locale}/delta-pro-3-portable-power-station?tab=support&active=form`;
    return (
        <div
            className={`${css.thecomp} GtmModuleData-section`}
            data-section-id={'dp3-ConsultingService'}
            data-section-title={'dp3-ConsultingService'}
            id="ConsultingService1"
        >
            <div className="dp3-spec"></div>
            <div className="dp3-title">
                {t.rich('title', {
                    code1: (text: string) => <span className="comp-sub-title">{text}</span>,
                })}
            </div>
            <div className="comp-in comp-box">
                <div className="comp-box-left">
                    <div className="comp-box-left-img">
                        <EditorImg
                            pc={
                                locale === 'jp'
                                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719299546795/a1.jpg'
                                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719048359518/cc1%20(1).jpg'
                            }
                            h5={
                                locale === 'jp'
                                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719299560174/a2.jpg'
                                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719048814985/image%2013%20(1).jpg'
                            }
                        />
                    </div>
                </div>
                <div className="comp-box-right">
                    <div className="comp-box-right-in">
                        {list.map((item, index) => {
                            if (!item.title || !item.desc) {
                                return null;
                            }
                            return (
                                <div key={index} className="comp-item">
                                    <div className="comp-item-icon">{item.icon}</div>
                                    <div className="comp-item-msgs">
                                        <div className="comp-item-title">{item.title}</div>
                                        <div className="comp-item-desc">{item.desc}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="comp-in comp-tips-desc">{t('desc')}</div>
            <EditorLink
                href={locale === 'jp' ? hrefJp : hrefCommon}
                className="comp-in comp-tips-btn"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'activity_preview',
                    button_name: t('btn'),
                }}
            >
                {t('btn')}
            </EditorLink>
            <div className="comp-in comp-tips-desc-2">{t('footer_tips')}</div>
        </div>
    );
};

export default TheComp;
